import React, { useState } from 'react'
import Eye from '@meprism/shared/src/assets/icons/showPassword.svg'
import SlashEye from '@meprism/shared/src/assets/icons/Hide.svg'
import {
  IconButton,
  InputAdornment,
  TextField,
  TextFieldProps,
} from '@mui/material'

const defaultProps = {
  color: 'primary',
  autoComplete: 'current-password',
} as const

export type PasswordFieldProps = TextFieldProps

const PasswordField = (props: PasswordFieldProps) => {
  const [shouldShowPassword, setShouldShowPassword] = useState<boolean>(false)

  const mergedProps = {
    ...defaultProps,
    ...props,
  }

  return (
    <TextField
      type={shouldShowPassword ? 'text' : 'password'}
      InputProps={{
        endAdornment: (
          <InputAdornment position={'end'}>
            <IconButton
              aria-label="Toggle Password Visibility"
              onClick={() => setShouldShowPassword(!shouldShowPassword)}
              edge="end">
              {shouldShowPassword ? <img alt='show password' src={SlashEye} style={{ width: 24, height: 24 }} /> :  <img alt='hide password' src={Eye} style={{ width: 24, height: 24 }} />}
            </IconButton>
          </InputAdornment>
        ),
      }}
      {...mergedProps}
    />
  )
}

export default PasswordField
